<template>
  <card @click.native="$emit('click')" :data-uuid="uuid" :class="[baseCss, 'font-semibold', 'select-none']" tag="div">
    <card-text>
      <table-layout y-align="middle" x-align="center">
        <row>
          <cell :class="[`${baseCss}-rows`, 'px-2']" v-if="showPositions">
            <table-layout y-align="middle" x-align="center">
              <row v-for="row in 8" :key="row">
                <cell v-html="9 - row" :class="['py-2']" />
              </row>
            </table-layout>
          </cell>
          <cell>
            <flex>
              <flex-col v-if="showPositions" :span="3" v-for="cell in 8" :key="`${cell}-top`" :class="['uppercase', 'flip-full']">
                <div v-html="letters[cell - 1]" :class="['py-2']" />
              </flex-col>
              <template v-for="row in 8">
                <flex-col :span="3" v-for="col in 8" :key="`${row}-${col}`" v-aspect-ratio="1/1" :class="[getPositionColor(row, col), 'text-center']">
                  <table-layout y-align="middle" v-aspect-ratio="1/1" x-align="center">
                    <row>
                      <cell :data-pos="position(row, col)" :title="position(row, col).toUpperCase()" :data-color="null" :data-piece="null" :class="[`${baseCss}-piece`, 'transition-all', 'duration-500', 'scale-0']" />
                    </row>
                  </table-layout>
                </flex-col>
              </template>
              <flex-col v-if="showPositions" :span="3" v-for="cell in 8" :key="`${cell}-bottom`" :class="['uppercase']">
                <div v-html="letters[cell - 1]" :class="['py-2']" />
              </flex-col>
            </flex>
          </cell>
          <cell v-if="showPositions" :class="[`${baseCss}-rows`, 'px-2']">
            <table-layout y-align="middle" x-align="center">
              <row v-for="row in 8" :key="row">
                <cell :class="['flip-full', 'py-2']" v-html="9 - row" />
              </row>
            </table-layout>
          </cell>
        </row>
      </table-layout>
      <reactive-style>
      .bcq-chessboard[data-uuid="{{ uuid }}"] .bcq-chessboard-piece::after
      {
        font-size: {{ pieceSize }};
      }
      .bcq-chessboard[data-uuid="{{ uuid }}"] [data-color="home"]
      {
        color: {{ pieceHomeColor }};
      }
      .bcq-chessboard[data-uuid="{{ uuid }}"] [data-color="away"]
      {
        color: {{ pieceAwayColor }};
      }
      </reactive-style>
    </card-text>
  </card>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Chessboard',
  mixins: [
    methods
  ],
  data () {
    return {
      uuid: this.$uuidv4(),
      baseCss: this.componentBaseCss('chessboard', []),
      letters: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h']
    }
  },
  props: {
    darkBgColor: {
      type: String,
      default: 'black'
    },
    darkBgColorLightness: {
      type: Number,
      default: null
    },
    lightBgColor: {
      type: String,
      default: 'white'
    },
    lightBgColorLightness: {
      type: Number,
      default: null
    },
    showPositions: {
      type: Boolean,
      default: true
    },
    home: {
      type: Array,
      default: () => {
        return []
      }
    },
    away: {
      type: Array,
      default: () => {
        return []
      }
    },
    pieceSize: {
      type: String,
      default: '3em'
    },
    pieceAwayColor: {
      type: String,
      default: 'teal'
    },
    pieceHomeColor: {
      type: String,
      default: 'crimson'
    }
  },
  watch: {
    away () {
      this.init()
      this.emit('away')
    },
    home () {
      this.init()
      this.emit()
    },
    showPositions () {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.reset()
      this.$nextTick(() => {
        this.setPositions()
        this.setPositions('away')
      })
    },
    emit (player = 'home') {
      this.$emit('change', {
        player,
        positions: this[player]
      })
    },
    reset () {
      this.$el.querySelectorAll('[data-piece]').forEach(box => {
        box.removeAttribute('data-piece')
        box.removeAttribute('data-color')
        box.classList.add('scale-0')
      })
    },
    setPositions (player = 'home') {
      this[player].forEach(item => {
        const position = item.position.toLowerCase()
        const piece = item.piece.toLowerCase()
        const box = this.$el.querySelector(`[data-pos="${position}"]`)
        if (box) {
          box.setAttribute('data-piece', piece)
          box.setAttribute('data-color', player)
          this.$nextTick(() => {
            box.classList.remove('scale-0')
          })
        }
      })
    },
    position (row, col) {
      return this.letters[col - 1] + (9 - row)
    },
    getPositionColor (row, col) {
      const dark = this.setBgColor('darkBgColor', 'darkBgColorLightness')
      const light = this.setBgColor('lightBgColor', 'lightBgColorLightness')
      return this.isEven(row) ? this.isEven(col) ? light : dark : !this.isEven(col) ? light : dark
    }
  }
}
</script>
<style>
.bcq-chessboard [data-color]::after
{
  font-weight: bold;
  font-family: "Arial Rounded MT", Arial, Helvetica, Sans-serif;
}

.bcq-chessboard [data-piece="rook"]::after
{
  content: "\2656";
}

.bcq-chessboard [data-piece="pawn"]::after
{
  content: "\2659";
}

.bcq-chessboard [data-piece="knight"]::after
{
  content: "\2658";
}

.bcq-chessboard [data-piece="bishop"]::after
{
  content: "\2657";
}

.bcq-chessboard [data-piece="king"]::after
{
  content: "\2654";
}

.bcq-chessboard [data-piece="queen"]::after
{
  content: "\2655";
}

.bcq-chessboard .bcq-flex:only-child
{
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/chessboard/chessboard.vue